<template lang="pug">

//- Одна плашка для всех ролей (решение владельца 01.11). «Не учтено» — внутренняя
//- отметка сотрудников, клиенту она ни к чему
span.shortage-mark(
  v-if="active && !(isClient && kind === 'balance')",
  :class="{ 'is-balance': kind === 'balance' }",
  :title="hint"
) {{ text }}

</template>

<script>
import { mapState } from 'vuex';
import { tr } from '@md/ui-text';
import { isType } from '@md/users/permissions';
import { CLIENT_TYPE } from '@md/users/accessTokens';

export default {
  name: 'shortage-mark',
  props: {
    active: { type: Boolean, default: true },
    count: { type: Number, default: 0 },
    // shortage | unidentified | balance
    kind: { type: String, default: 'shortage' },
  },
  computed: {
    ...mapState('users/auth', ['user']),
    isClient() {
      return !!(this.user && this.user.info && isType(CLIENT_TYPE, this.user));
    },
    label() {
      if (this.kind === 'unidentified') return 'Unidentified UA';
      if (this.kind === 'balance') {
        return tr('Не враховано', 'Не учтено', 'Not on balance', '未计入余额');
      }
      return tr('Недоїзд', 'Недоезд', 'Shortage', '短缺');
    },
    hint() {
      if (!this.isClient || this.kind !== 'shortage') return this.label;
      return tr(
        'Місце ще не доїхало, ми його шукаємо. Менеджер повідомить вас.',
        'Место ещё не доехало, мы его ищем. Менеджер сообщит вам.',
        'The parcel has not arrived yet, we are looking for it. Your manager will let you know.',
        '包裹尚未到达，我们正在查找。经理会通知您。'
      );
    },
    text() {
      return this.count ? `${this.label}: ${this.count}` : this.label;
    },
  },
};
</script>
